import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { PuntoIntermedio, ResumenTareasService } from 'src/app/services/resumen-tareas.service';
import { HttpClient } from '@angular/common/http';

import { decode } from '@here/flexpolyline'
import { MatDialog } from '@angular/material/dialog';
import { PlaceDetailDialogComponent } from 'src/app/place-detail-dialog/place-detail-dialog.component';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { catchError, switchMap, tap } from 'rxjs/operators';
import { of } from 'rxjs';
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Component({
  selector: 'app-FragmentMapaPlanificadorRutas',
  templateUrl: './FragmentMapaPlanificadorRutas.component.html', // Usa solo templateUrl
  styleUrls: ['./FragmentMapaPlanificadorRutas.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class FragmentMapaPlanificadorRutas implements AfterViewInit, OnDestroy {
  @ViewChild('mapContainer', { static: false }) mapContainer: ElementRef;

  googleMap: any;
  rutas: any[] = [];
  markers: google.maps.Marker[] = [];
  polylines: google.maps.Polyline[] = [];
  isLoading = true;
  tollMarkersGoogle: any[] = [];
   polylineRuta: any;
     marcadoresGoogle: any[] = [];
 resumenRuta: any;
  constructor(
    private http: HttpClient, 
    private resumenTareasService: ResumenTareasService,
    private dialog: MatDialog
  ) {}

  ngAfterViewInit() {
    this.initializeMap();
    this.loadRutas();
  }

  ngOnDestroy() {
    this.clearMap();
  }

  initializeMap() {
    this.googleMap = new google.maps.Map(this.mapContainer.nativeElement, {
      center: { lat: 4.5709, lng: -74.2973 }, // Centro de Colombia
      zoom: 6,
      styles: [
        {
          featureType: "poi",
          elementType: "labels",
          stylers: [{ visibility: "off" }] // Oculta puntos de interés
        },
        {
          featureType: "transit",
          elementType: "labels.icon",
          stylers: [{ visibility: "off" }] // Oculta iconos de tránsito
        }
      ],
      mapTypeControlOptions: {
        style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
        position: google.maps.ControlPosition.TOP_RIGHT
      }
    });
  }

  loadRutas() {
    this.isLoading = true;
    this.resumenTareasService.getRutasViajeros(localStorage.getItem("negocio"),localStorage.getItem("agencia")).subscribe({
      next: (response) => {
        this.rutas = response.rutas || [];
        this.pintarTodosLosPuntos();
        this.isLoading = false;
      },
      error: (err) => {
        console.error('Error cargando rutas:', err);
        this.isLoading = false;
      }
    });
  }

  crearMarcador(position: google.maps.LatLng, ruta: any, tipo: 'origen' | 'destino' | 'intermedio') {
    // Configuración por tipo de marcador
    const config = {
      origen: {
        color: '#4285F4', // Azul Google
        label: 'O',
        title: `ORIGEN: ${ruta.origen}`,
        fecha: this.formatearFecha(ruta.hora_salida),
        textoExtra: 'SALIDA',
        hora: this.extraerHora(ruta.hora_salida)
      },
      destino: {
        color: '#EA4335', // Rojo Google
        label: 'D',
        title: `DESTINO: ${ruta.destino}`,
        fecha: this.formatearFecha(ruta.hora_llegada),
        textoExtra: 'LLEGADA',
        hora: this.extraerHora(ruta.hora_llegada)
      },
      intermedio: {
        color: '#FBBC05', // Amarillo Google
        label: '1',
        title: `PUNTO INTERMEDIO: ${ruta.punto_intermedio_1_direccion || 'Sin nombre'}`,
        fecha: '',
        textoExtra: 'INTERMEDIO',
        hora: ''
      }
    }[tipo];

    // Crear canvas para el marcador
    const canvas = document.createElement('canvas');
    const width = 80;  // Ancho del marcador
    const height = 50; // Alto del marcador
    canvas.width = width;
    canvas.height = height;
    const context = canvas.getContext('2d');
    
    if (context) {
      // Dibujar forma de banderín
      context.beginPath();
      context.moveTo(0, 15);
      context.lineTo(15, 0);
      context.lineTo(width - 1, 0);
      context.lineTo(width - 1, height - 15);
      context.lineTo(width - 15, height);
      context.lineTo(0, height);
      context.closePath();
      
      // Rellenar con color
      context.fillStyle = config.color;
      context.fill();
      
      // Borde blanco
      context.strokeStyle = '#FFFFFF';
      context.lineWidth = 2;
      context.stroke();
      
      // Texto de la fecha (parte superior)
      if (config.fecha) {
        context.fillStyle = '#FFFFFF';
        context.font = 'bold 10px Arial';
        context.textAlign = 'center';
        context.fillText(config.fecha, width/2, 13);
      }
      
      // Texto de la hora (parte media)
      if (config.hora) {
        context.fillStyle = '#FFFFFF';
        context.font = 'bold 11px Arial';
        context.textAlign = 'center';
        context.fillText(config.hora, width/2, 27);
      }
      
      // Texto principal (letra grande abajo)
      context.fillStyle = '#FFFFFF';
      context.font = 'bold 16px Arial';
      context.textAlign = 'center';
      context.fillText(config.label, width/2, height - 10);
    }

    // Contenido del tooltip
    const contentString = `
      <div style="padding: 12px; min-width: 280px; font-family: 'Roboto', Arial, sans-serif;">
        <div style="color: ${config.color}; font-weight: bold; font-size: 15px; margin-bottom: 8px; border-bottom: 1px solid #eee; padding-bottom: 6px;">
          ${config.title}
        </div>
        <div style="font-size: 13px; margin-bottom: 6px;">
          <strong>${config.textoExtra}:</strong> ${tipo === 'origen' ? ruta.hora_salida : tipo === 'destino' ? ruta.hora_llegada : 'N/A'}
        </div>
        <div style="font-size: 13px; margin-bottom: 6px;">
          <strong>Guía:</strong> ${ruta.guia}
        </div>
        ${tipo === 'destino' ? `
        <div style="font-size: 13px; margin-bottom: 4px;">
          <strong>Duración:</strong> ${ruta.duracion_total}
        </div>
        <div style="font-size: 13px;">
          <strong>Distancia:</strong> ${ruta.distancia_total}
        </div>
        ` : ''}
      </div>
    `;

    const marker = new google.maps.Marker({
      position,
      map: this.googleMap,
      title: config.title,
      icon: {
        url: canvas.toDataURL(),
        scaledSize: new google.maps.Size(width, height),
        anchor: new google.maps.Point(width/2, height)
      },
      optimized: false
    });

    const infoWindow = new google.maps.InfoWindow({
      content: contentString,
      maxWidth: 300
    });

    marker.addListener('click', () => {
      this.cerrarTodosLosInfoWindows();
      infoWindow.open(this.googleMap, marker);
      (marker as any).infoWindow = infoWindow;
    });

    this.markers.push(marker);
    return marker;
  }

  pintarTodosLosPuntos() {
    this.clearMap();
    const bounds = new google.maps.LatLngBounds();

    this.rutas.forEach(ruta => {
      // Pintar origen
      if (ruta.origen_latitud && ruta.origen_longitud) {
        const origenLatLng = new google.maps.LatLng(ruta.origen_latitud, ruta.origen_longitud);
        this.crearMarcador(origenLatLng, ruta, 'origen');
        bounds.extend(origenLatLng);
      }

      // Pintar destino
      if (ruta.destino_latitud && ruta.destino_longitud) {
        const destinoLatLng = new google.maps.LatLng(ruta.destino_latitud, ruta.destino_longitud);
        this.crearMarcador(destinoLatLng, ruta, 'destino');
        bounds.extend(destinoLatLng);
      }

      // Pintar puntos intermedios
      if (ruta.punto_intermedio_1_latitud && ruta.punto_intermedio_1_longitud) {
        const puntoLatLng = new google.maps.LatLng(
          ruta.punto_intermedio_1_latitud,
          ruta.punto_intermedio_1_longitud
        );
        this.crearMarcador(puntoLatLng, ruta, 'intermedio');
        bounds.extend(puntoLatLng);
      }
    });

    if (!bounds.isEmpty()) {
      this.googleMap.fitBounds(bounds, { padding: 50 });
      
      // Ajustar zoom después de un pequeño retraso para evitar problemas
      setTimeout(() => {
        const zoom = this.googleMap.getZoom();
        if (zoom > 12) this.googleMap.setZoom(12);
        if (zoom < 6) this.googleMap.setZoom(6);
      }, 100);
    }
  }

 verRutaCompleta(ruta: any): void {
  this.clearMap();

  this.resumenTareasService.getRutaViajeroPorGuia(ruta.guia).pipe(
    tap((data: any) => {
      console.log('Ruta encontrada:', data);

      // Pintar origen
      if (ruta.origen_latitud && ruta.origen_longitud) {
        const origenLatLng = new google.maps.LatLng(ruta.origen_latitud, ruta.origen_longitud);
        this.crearMarcador(origenLatLng, ruta, 'origen');
      }

      // Pintar destino
      if (ruta.destino_latitud && ruta.destino_longitud) {
        const destinoLatLng = new google.maps.LatLng(ruta.destino_latitud, ruta.destino_longitud);
        this.crearMarcador(destinoLatLng, ruta, 'destino');
      }

      // Pintar punto intermedio
      if (ruta.punto_intermedio_1_latitud && ruta.punto_intermedio_1_longitud) {
        const puntoLatLng = new google.maps.LatLng(
          ruta.punto_intermedio_1_latitud,
          ruta.punto_intermedio_1_longitud
        );
        this.crearMarcador(puntoLatLng, ruta, 'intermedio');
      }

      // Decodificar polilíneas y pintar en mapa
      let polylinePoints: { lat: number; lng: number }[] = [];
      for (let section of data.rutas || []) {
        const decoded = decode(section);
        const points = decoded.polyline.map((pair: number[]) => ({
          lat: pair[0],
          lng: pair[1]
        }));
        polylinePoints = polylinePoints.concat(points);
      }
      this.pintarTramoHereEnMapa(polylinePoints);
    }),

    // Paso 2: getRutasViajerosPlanilla
    switchMap(() => this.resumenTareasService.getRutasViajerosPlanilla(ruta.guia).pipe(
      tap((data: any) => {
        console.log('Ruta getRutasViajerosPlanilla:', data);
this.resumenRuta = {
  ...this.resumenRuta,
  tramos: [],
  // otras propiedades si es necesario
};
        this.resumenRuta.tramos = data.rutas
        this.pintarPasosDetallados(data.rutas);
      })
    )),

    // Paso 3: getRutasViajerosDetalle
    switchMap(() => this.resumenTareasService.getRutasViajerosDetalle(ruta.guia).pipe(
      tap((data: any) => {
        console.log('Ruta getRutasViajerosDetalle:', data);
        this.pintarListaPasos(data.rutas);
      })
    )),

    // Paso 4: getRutasViajerosPeajes
    switchMap(() => this.resumenTareasService.getRutasViajerosPeajes(ruta.guia).pipe(
      tap((data: any) => {
        console.log('Ruta getRutasViajerosPeajes:', data);
        this.pintarPeajes(data.rutas);
      })
    )),

    // Capturar errores globalmente
    catchError((err) => {
      console.error('Error en la carga de rutas:', err);
      return of(null); // Devuelve observable vacío para continuar la cadena
    })
  ).subscribe();
}


  public exportAsExcelFile(json: any[], excelFileName: string): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }
  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
    FileSaver.saveAs(data, fileName + ''+ EXCEL_EXTENSION);
  }

  private generarNombreArchivo(baseName: string): string {
  const now = new Date();
  
  // Formatear fecha como DD-MM-YYYY
  const day = String(now.getDate()).padStart(2, '0');
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const year = now.getFullYear();
  
  // Formatear hora como HH-MM-SS
  const hours = String(now.getHours()).padStart(2, '0');
  const minutes = String(now.getMinutes()).padStart(2, '0');
  const seconds = String(now.getSeconds()).padStart(2, '0');
  
  return `${baseName}_${day}-${month}-${year}_${hours}-${minutes}-${seconds}`;
}


cerrarDetalle(): void {
  this.resumenRuta = null;
 this.initializeMap();
    this.loadRutas();

}

 descargarRuta(ruta: any): void {

  this.resumenTareasService.getRutaViajeroPorGuia(ruta.guia).pipe(
    tap((data: any) => {
      console.log('Ruta encontrada:', data);

    }),

    // Paso 2: getRutasViajerosPlanilla
    switchMap(() => this.resumenTareasService.getRutasViajerosPlanilla(ruta.guia).pipe(
      tap((data: any) => {
        console.log('Ruta getRutasViajerosPlanilla:', data);
this.resumenRuta = {
  ...this.resumenRuta,
  tramos: [],
  // otras propiedades si es necesario
};
        this.resumenRuta.tramos = data.rutas
          this.exportAsExcelFile(data.rutas, this.generarNombreArchivo('planillas'));
      
      })
    )),

    // Paso 3: getRutasViajerosDetalle
    switchMap(() => this.resumenTareasService.getRutasViajerosDetalle(ruta.guia).pipe(
      tap((data: any) => {
        console.log('Ruta getRutasViajerosDetalle:', data);
          this.exportAsExcelFile(data.rutas, this.generarNombreArchivo('detalles'));
       
      })
    )),

    // Paso 4: getRutasViajerosPeajes
    switchMap(() => this.resumenTareasService.getRutasViajerosPeajes(ruta.guia).pipe(
      tap((data: any) => {
        console.log('Ruta getRutasViajerosPeajes:', data);
               this.exportAsExcelFile(data.rutas, this.generarNombreArchivo('peajes'));
   
      })
    )),

    // Capturar errores globalmente
    catchError((err) => {
      console.error('Error en la carga de rutas:', err);
      return of(null); // Devuelve observable vacío para continuar la cadena
    })
  ).subscribe();
}


  pintarPeajes(peajes: any[]): void {
  if (!peajes || !Array.isArray(peajes)) return;

  const bounds = new google.maps.LatLngBounds();

  for (let i = 0; i < peajes.length; i++) {
    const p = peajes[i];

    const latLng = new google.maps.LatLng(p.latitud, p.longitud);

    const marker = new google.maps.Marker({
      position: latLng,
      map: this.googleMap,
      icon: {
        url: 'https://maps.google.com/mapfiles/ms/icons/yellow-dot.png'
      }
    });

    const content = `
      <div style="max-width: 250px;">
        <strong>Ubicación:</strong> ${p.ubicacion || 'Desconocida'}<br/>
        <strong>Sistema:</strong> ${p.sistema_peaje || '-'}<br/>
        <strong>Tarifa:</strong> ${p.valor_tarifa ? '$' + p.valor_tarifa.toLocaleString() : 'No disponible'}<br/>
        <strong>Moneda:</strong> ${p.moneda || 'COP'}<br/>
        <strong>Métodos de pago:</strong> ${p.metodos_pago || '-'}<br/>
        <a href="https://www.google.com/maps?q=${p.latitud},${p.longitud}" target="_blank">📍 Ver en Google Maps</a>
      </div>
    `;

    const infoWindow = new google.maps.InfoWindow();

    google.maps.event.addListener(marker, 'click', (function (contentCopy, markerCopy) {
      return function () {
        infoWindow.setContent(contentCopy);
        infoWindow.open(this.googleMap, markerCopy);
      };
    }).bind(this)(content, marker));

    this.tollMarkersGoogle.push(marker);
    bounds.extend(latLng);
  }

  this.googleMap.fitBounds(bounds);
}


  // Helper functions
  formatearFecha(fechaCompleta: string): string {
    if (!fechaCompleta) return '';
    try {
      const fecha = new Date(fechaCompleta);
      return fecha.toLocaleDateString('es-CO', {
        day: '2-digit',
        month: 'short'
      }).replace('.', '').toUpperCase();
    } catch (e) {
      console.error('Error formateando fecha:', e);
      return '';
    }
  }

  extraerHora(fechaCompleta: string): string {
    if (!fechaCompleta) return '';
    try {
      const fecha = new Date(fechaCompleta);
      return fecha.toLocaleTimeString('es-CO', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
      }).toLowerCase();
    } catch (e) {
      console.error('Error extrayendo hora:', e);
      return '';
    }
  }

  cerrarTodosLosInfoWindows() {
    this.markers.forEach(marker => {
      if ((marker as any).infoWindow) {
        (marker as any).infoWindow.close();
      }
    });
  }

  pintarListaPasos(pasos: any[]) {
  if (!pasos || !pasos.length) return;

  const bounds = new google.maps.LatLngBounds();
  const infoWindow = new google.maps.InfoWindow();

  if (!this.marcadoresGoogle) this.marcadoresGoogle = [];

  for (let i = 0; i < pasos.length; i++) {
    const paso = pasos[i];

    // Validar que tenga ubicación de inicio
    if (paso.Latitud_Inicio != null && paso.Longitud_Inicio != null) {
      const posicion = new google.maps.LatLng(paso.Latitud_Inicio, paso.Longitud_Inicio);

      const content = `
        <div style="max-width: 250px;">
          <strong>Dirección:</strong><br/> ${paso.Direccion || 'No disponible'}<br/><br/>
          <strong>Instrucciones:</strong><br/> ${paso.Instrucciones || 'Sin instrucciones'}<br/><br/>
          <strong>Distancia:</strong> ${paso.Distancia_texto || 'N/A'}<br/>
          <strong>Duración:</strong> ${paso.Duracion_texto || 'N/A'}<br/>
        </div>
      `;

      const marker = new google.maps.Marker({
        position: posicion,
        map: this.googleMap,
        icon: {
          url: 'https://maps.google.com/mapfiles/ms/icons/green-dot.png'
        }
      });

      google.maps.event.addListener(marker, 'click', (function (contentCopy, markerCopy) {
        return function () {
          infoWindow.setContent(contentCopy);
          infoWindow.open(this.googleMap, markerCopy);
        };
      })(content, marker));

      this.marcadoresGoogle.push(marker);
      bounds.extend(posicion);
    }
  }

  // Ajustar el zoom del mapa a todos los puntos
  this.googleMap.fitBounds(bounds);
}


  clearMap() {
    this.cerrarTodosLosInfoWindows();
    
    // Limpiar marcadores
    this.markers.forEach(marker => marker.setMap(null));
    this.markers = [];
    
    // Limpiar polilíneas
    this.polylines.forEach(line => line.setMap(null));
    this.polylines = [];

    this.initializeMap()
  }


 pintarTramoHereEnMapa(puntos: { lat: number; lng: number }[]): void {
  if (!this.googleMap || !puntos || puntos.length === 0) {
    return;
  }

  const polyline = new google.maps.Polyline({
    path: puntos,
    geodesic: true,
    strokeColor: '#00796B', // verde oscuro HERE
    strokeOpacity: 0.8,
    strokeWeight: 5
  });

  polyline.setMap(this.googleMap);
 
}

private coloresTramos: string[] = [
  '#e6194b', // rojo fuerte
  '#3cb44b', // verde fuerte
  '#ffe119', // amarillo fuerte
  '#0082c8', // azul intenso
  '#f58231', // naranja
  '#911eb4', // púrpura fuerte
  '#f032e6', // magenta
  '#008080', // teal
  '#aa6e28', // marrón oscuro
  '#800000', // vino tinto
  '#808000', // oliva fuerte
  '#000080', // azul marino
  '#808080'  // gris medio
];

getColorByIndex(index: number, total: number): string {
  return this.coloresTramos[index % this.coloresTramos.length];
}

pintarPasosDetallados(pasosDetallados: any[]) {
  const bounds = new google.maps.LatLngBounds();

  this.marcadoresGoogle = [];
  this.tollMarkersGoogle = [];

  for (let i = 0; i < pasosDetallados.length; i++) {
    const paso = pasosDetallados[i];
    const color = this.getColorByIndex(i, pasosDetallados.length);

    // 🚗 Procesar todos los sub-steps si existen
    if (paso.steps && paso.steps.length) {
      for (let j = 0; j < paso.steps.length; j++) {
        const step = paso.steps[j];
        if (step.polyline && step.polyline.points) {
          const puntos = this.decodeGooglePolyline(step.polyline.points);

          // 🟢 Dibujar línea del sub-step
          const polyline = new google.maps.Polyline({
            path: puntos,
            geodesic: true,
            strokeColor: "#FF0000",
            strokeOpacity: 1.0,
            strokeWeight: 4
          });
          polyline.setMap(this.googleMap);
          this.marcadoresGoogle.push(polyline);

          // Expandir el mapa a los puntos
          for (let k = 0; k < puntos.length; k++) {
            bounds.extend(puntos[k]);
          }

          // 🟢 Dibujar geozona convexa
          const geozonaCoords = this.createConvexHull(puntos);
          const geozona = new google.maps.Polygon({
            paths: geozonaCoords,
            strokeColor: color,
            strokeOpacity: 0.8,
            strokeWeight: 2,
            fillColor: color,
            fillOpacity: 0.3
          });
          geozona.setMap(this.googleMap);
          this.marcadoresGoogle.push(geozona);
        }
      }
    }

    // 🟢 Crear información para los marcadores
    var direccion = paso.direccion ? paso.direccion : 'No disponible';
    var instruccion = paso.html_instructions ? paso.html_instructions : 'Sin instrucciones';
    var distancia = paso.distance && paso.distance.text ? paso.distance.text : 'N/A';
    var duracion = paso.duration && paso.duration.text ? paso.duration.text : 'N/A';

    var content =
      '<div style="max-width: 250px;">' +
        '<strong>Dirección:</strong><br/>' + direccion + '<br/><br/>' +
        '<strong>Instrucción:</strong><br/>' + instruccion + '<br/><br/>' +
        '<strong>Distancia:</strong> ' + distancia + '<br/>' +
        '<strong>Duración:</strong> ' + duracion +
      '</div>';

    var infoWindow = new google.maps.InfoWindow();

    // 🔵 Marcador de inicio
    if (paso.start_location) {
      const markerStart = new google.maps.Marker({
        position: paso.start_location,
        map: this.googleMap,
        icon: {
          url: 'https://maps.google.com/mapfiles/ms/icons/blue-dot.png'
        }
      });

      google.maps.event.addListener(markerStart, 'click', (function (contentCopy, markerCopy) {
        return function () {
          infoWindow.setContent(contentCopy);
          infoWindow.open(this.googleMap, markerCopy);
        };
      })(content, markerStart));

      this.marcadoresGoogle.push(markerStart);
      bounds.extend(paso.start_location);
    }

    // 🔴 Marcador de fin
    if (paso.end_location) {
      const markerEnd = new google.maps.Marker({
        position: paso.end_location,
        map: this.googleMap,
        icon: {
          url: 'https://maps.google.com/mapfiles/ms/icons/red-dot.png'
        }
      });

      google.maps.event.addListener(markerEnd, 'click', (function (contentCopy, markerCopy) {
        return function () {
          infoWindow.setContent(contentCopy);
          infoWindow.open(this.googleMap, markerCopy);
        };
      })(content, markerEnd));

      this.marcadoresGoogle.push(markerEnd);
      bounds.extend(paso.end_location);
    }
  }

  // Ajustar vista del mapa
  this.googleMap.fitBounds(bounds);
}


createConvexHull(points: google.maps.LatLngLiteral[]): google.maps.LatLngLiteral[] {
  if (points.length < 3) return points;

  const uniquePoints = Array.from(new Set(points.map(p => `${p.lat},${p.lng}`)))
    .map(p => {
      const [lat, lng] = p.split(',');
      return { lat: parseFloat(lat), lng: parseFloat(lng) };
    });

  const sorted = uniquePoints.sort((a, b) => a.lat === b.lat ? a.lng - b.lng : a.lat - b.lat);

  const crossProduct = (o, a, b) =>
    (a.lat - o.lat) * (b.lng - o.lng) - (a.lng - o.lng) * (b.lat - o.lat);

  const lower: google.maps.LatLngLiteral[] = [];
  for (const point of sorted) {
    while (lower.length >= 2 && crossProduct(lower[lower.length - 2], lower[lower.length - 1], point) < 0) {
      lower.pop();
    }
    lower.push(point);
  }

  const upper: google.maps.LatLngLiteral[] = [];
  for (const point of sorted.reverse()) {
    while (upper.length >= 2 && crossProduct(upper[upper.length - 2], upper[upper.length - 1], point) < 0) {
      upper.pop();
    }
    upper.push(point);
  }

  upper.pop();
  lower.pop();

  return lower.concat(upper);
}

  decodeGooglePolyline(encoded: string): { lat: number, lng: number }[] {
  let index = 0;
  const len = encoded.length;
  let lat = 0;
  let lng = 0;
  const coordinates = [];

  while (index < len) {
    let shift = 0;
    let result = 0;
    let byte: number;

    // Decode latitude
    do {
      byte = encoded.charCodeAt(index++) - 63;
      result |= (byte & 0x1F) << shift;
      shift += 5;
    } while (byte >= 0x20);
    const deltaLat = (result & 1) ? ~(result >> 1) : (result >> 1);
    lat += deltaLat;

    // Decode longitude
    shift = 0;
    result = 0;
    do {
      byte = encoded.charCodeAt(index++) - 63;
      result |= (byte & 0x1F) << shift;
      shift += 5;
    } while (byte >= 0x20);
    const deltaLng = (result & 1) ? ~(result >> 1) : (result >> 1);
    lng += deltaLng;

    coordinates.push({ lat: lat * 1e-5, lng: lng * 1e-5 });
  }

  return coordinates;
}

}